import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PaymentCard } from '@core/models/payment-card.model';
import {
  animate,
  keyframes,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Subject } from 'rxjs';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { GonativeService } from '@core/services/gonative/gonative.service';
import { AnimationStates } from '../../modal-repeat-purchase.component';

@Component({
  standalone: true,
  selector: 'app-token-card-edit',
  templateUrl: './token-card-edit.component.html',
  styleUrls: ['./token-card-edit.component.scss'],
  imports: [CommonModule, RouterModule, SvgIconComponent],
  animations: [
    trigger('inOutAnimationTokenEdit', [
      transition('* => desktopEnter', [
        style({ transform: 'translateX(100%)' }),
        animate('.3s', keyframes([style({ transform: 'translateX(0%)' })]))
      ]),
      transition('* => desktopLeave', [
        style({ transform: 'translateX(0%)' }),
        animate('.3s', keyframes([style({ transform: 'translateX(100%)' })]))
      ]),
      transition('* => mobileEnter', [
        style({ transform: 'translateY(100%)' }),
        animate('.3s', keyframes([style({ transform: 'translateY(0%)' })]))
      ]),
      transition('* => mobileLeave', [
        style({ transform: 'translateY(0%)' }),
        animate('.3s', keyframes([style({ transform: 'translateY(100%)' })]))
      ])
    ])
  ]
})
export class TokenCardEditComponent {
  @Input() stepModal: number | null = null;
  @Input() paymentCards: PaymentCard[] | null = null;
  @Input() isEditingPaymentCard: boolean = false;
  @Input() selectedPaymentCard: PaymentCard | null = null;
  @Input() disabled: boolean | null = false;
  @Output() hideModalEditToken = new EventEmitter();
  @Output() handleSubmitNewPayment = new EventEmitter();

  @Input() animationStateTokenEdit: AnimationStates;

  handleHideModalTokenEdit() {
    this.hideModalEditToken.emit();
  }
  handleChangePaymentMethod(value: PaymentCard | null) {
    this.selectedPaymentCard = value;
  }
  handleSubmit() {
    this.handleSubmitNewPayment.emit();
  }
}
